import React, { useEffect, useState } from 'react'
import './Search.scss'
import { connect } from 'react-redux';
import { showSearch, showSpinner, setPaginationState, setProductsTable, resetFilters, setAllProducts, setSelectedCategory } from '../actions'
import { useActiveDesactiveSrollBody } from '../hooks/activeDesactivScrollBody';
import * as _ from 'lodash'
import { useNavigate } from 'react-router-dom';
import { DobleGuion } from './DobleGuion';
import { EquisIcons } from '../utils/icons';
import { getProducts, getProductsExpositors, getProductsImplantations, getProductsOutlet, getProductsPromoA, getProductsPromoB, getProductsPromoC } from '../hooks/gets';
import { BRANDCHOSEN } from '../hooks/config';

const Search = (props) => {
    const [open, setOpen] = useState(false)
    const [wordSearch, setWordSearch] = useState(false)
    const navigate = useNavigate();
    useEffect(() => {
        setOpen(props.search)
    }, [props.search])

    const handleClickSearch = async () => {
        props.showSpinner(true)
        try {
            let allProducts = await getProducts()
            if(BRANDCHOSEN == 'fansa'){
              const outlet = await getProductsOutlet()
              const expositors = await getProductsExpositors()
              const promoA = await getProductsPromoA()
              const promoB = await getProductsPromoB()
              const promoC = await getProductsPromoC()
              allProducts = allProducts[BRANDCHOSEN].concat(outlet.data).concat(expositors.data).concat(promoA.data).concat(promoB.data).concat(promoC.data)
            }else if(BRANDCHOSEN == 'scheurich'){
              const implantations = await getProductsImplantations()
              allProducts = allProducts[BRANDCHOSEN].concat(implantations.data)
            }else{
              allProducts = allProducts[BRANDCHOSEN]
            }

            const productsFilter = _.filter(allProducts, product => {
                return product.RefSuelto.toLowerCase().indexOf(wordSearch.toLowerCase()) > -1 || product.Descripcion.toLowerCase().indexOf(wordSearch.toLowerCase()) > -1
            })
            await props.setSelectedCategory({
                categoryId: '',
                subtitle: '',
                img: '',
                selectedCollection: ''
            })
            props.setAllProducts(productsFilter)
            props.setPaginationState(1)
            props.setProductsTable('allProductsSearch')
            props.resetFilters()
            navigate(`/categoria`)
            handleClickHiddenSearch()
        } catch (error) {
            props.showSpinner(false)
            console.log('error', error)
        }
    }

    const handleClickHiddenSearch = () => {
        props.showSearch(false)
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useActiveDesactiveSrollBody(false)
    }

    return (
        <React.Fragment>
            {
                open &&
                <div className="search-container">
                    <div className="search-content">
                        <div className="title">
                            <div className="text">
                                <p>BUSCADOR</p>
                                <DobleGuion />
                            </div>
                            <div className="botones">
                                <button className="pointer" onClick={handleClickHiddenSearch}><EquisIcons size={15} /></button>
                            </div>
                        </div>
                        <div className="input-block">
                            <div className="input">
                                <input type="text" onChange={event => setWordSearch(event.target.value)} placeholder="Nombre o referencia" />
                            </div>
                        </div>
                        <div className="botones">
                            <button className="btn" onClick={handleClickSearch}>Buscar</button>
                        </div>
                    </div>
                </div>
            }
        </React.Fragment>
    )
}

const mapStateToProps = state => state

const mapDispatchToProps = {
    showSearch,
    showSpinner,
    setPaginationState,
    setProductsTable,
    resetFilters,
    setAllProducts,
    setSelectedCategory
}

export default connect(mapStateToProps, mapDispatchToProps)(Search)
